<script lang="ts">
export default { name: 'LayoutContentFallback' };
</script>

<script lang="ts" setup>
import type {
  LayoutContentGateEmits,
  LayoutContentGateProps,
} from '@/shared/layouts/types/mainLayout.type';

defineProps<LayoutContentGateProps>();
defineEmits<LayoutContentGateEmits>();
</script>

<template>
  <div v-if="isStatusReady" class="flex flex-col flex-grow overflow-y-auto">
    <slot />
  </div>
</template>
